import { pages } from '@/config'

import {
  initRoutesMeta,
  getNavMenuConfig,
  downToUpReduceMetaAuthority,
} from '@/utils/router'

const HomeLayout = () => import(/* webpackChunkName: "home" */ '@/layout/HomeLayout.vue')
const HomePage = () => import(/* webpackChunkName: "home" */ '@/views/HomePage')

const UserMana = () => import(/* webpackChunkName: "userMana" */ '@/views/UserMana')
const SystemLog = () => import(/* webpackChunkName: "systemLog" */ '@/views/SystemLog')

const DevicePage = () => import(/* webpackChunkName: "devicePage" */ '@/views/DevicePage')

const LoginPage = () => import(/* webpackChunkName: "login" */ '@/views/LoginPage')

const NoFind = () => import(/* webpackChunkName: "404" */ '@/views/Exception/404.vue')
const NoPermission = () => import(/* webpackChunkName: "403" */ '@/views/Exception/403.vue')

const routes = [
  {
    path: '/home',
    component: HomeLayout,
    meta: { hideInMenu: true },
    children: [
      {
        path: '',
        alias: pages.home.name,
        name: pages.home.name,
        component: HomePage,
        meta: {
          name: '综合统计',
          title: '综合统计',
          icon: 'totalAnylisis',
          authority: true,
        },
      },
    ],
  },
  // {
  //   path: 'infoMana',
  //   meta: { name: '信息管理', icon: 'infoMana', path: 'http://www.baidu.com' },
  // },
  {
    path: '/devicePage',
    component: HomeLayout,
    meta: { hideInMenu: true },
    children: [
      {
        path: '',
        name: 'devicePage',
        component: DevicePage,
        meta: {
          name: '设备管理',
          title: '设备管理',
          icon: 'device',
          authority: true,
        },
      },
    ],
  },
  {
    path: '/systemMana',
    component: HomeLayout,
    meta: { name: '系统管理', icon: 'system' },
    children: [
      {
        path: '',
        name: 'userMana',
        component: UserMana,
        meta: {
          name: '用户管理',
          title: '用户管理',
          authority: ['SYSTEM_ADMINER'],
        },
      },
      // {
      //   path: 'systemLog',
      //   name: 'systemLog',
      //   component: SystemLog,
      //   meta: {
      //     name: '登录日志',
      //     title: '登录日志',
      //     // authority: ['SYSTEM_ADMINER'],
      //   },
      // },
    ],
  },
  {
    path: pages.login.path,
    name: pages.login.name,
    component: LoginPage,
    meta: {
      title: '登录页面',
      hideInMenu: true,
    },
  },
  {
    path: '/',
    redirect: pages.home.path,
    meta: { hideInMenu: true },
  },
  {
    path: '/403',
    component: NoPermission,
    meta: { hideInMenu: true, title: '你没有权限访问该页面' },
  },
  {
    path: '*',
    component: NoFind,
    meta: { hideInMenu: true, title: '没有找到你要去的页面' },
  },
]

const reduceRoute = downToUpReduceMetaAuthority(initRoutesMeta(routes))

export const navMenuConfig = getNavMenuConfig(reduceRoute)

export default reduceRoute
